import React from 'react';
import PropTypes from 'prop-types';

const Weekday = ({ weekday, locale, localeUtils, className }) => {
  const weekdayName = localeUtils.formatWeekdayLong(weekday, locale);

  return (
    <div className={className} title={weekdayName}>
      {weekdayName.slice(0, 2)}
    </div>
  );
};

Weekday.propTypes = {
  weekday: PropTypes.number,
  className: PropTypes.string,
  localeUtils: PropTypes.object,
  locale: PropTypes.string,
};

export default Weekday;
